export enum Actions {
  View = "view",
  Click = "click",
}

/**
 * The original implementation used SelfDescribingEvents. This accounts for the Schemas that have *_event appended
 * to their name. The intended final state is to use Snowplow built-in events, or a generic reusable event, and
 * attach "entities" to the context of those events. This is best practice, and this inconsistency is due to
 * the change in pattern. This comment should be removed when we move to the new pattern.
 */
export enum Schemas {
  PromotionEvent = "iglu:com.ltk.commerce/promotion_event/jsonschema/1-0-0", // when a user sees a post on screen
  ProductEvent = "iglu:com.ltk.commerce/product_event/jsonschema/1-0-0", // when a user sees a product on screen
  ShopEntity = "iglu:com.ltk.commerce/shop/jsonschema/1-0-1", // when a user visits a creator shop
  PromotionEntity = "iglu:com.ltk.commerce/promotion/jsonschema/1-0-1", // when a user visits a creator shop
  UserMetaEntity = "iglu:com.ltk.commerce/user_meta/jsonschema/1-0-0", // vid entity added to global context
  ImpressionEvent = "iglu:com.ltk/impression/jsonschema/1-0-0",
  BrandEntity = "iglu:com.ltk/brand/jsonschema/1-0-0",
}
